// extracted by mini-css-extract-plugin
export default {"imageButton":"ordering_imageButton__v55sY","imageButtonWrapper":"ordering_imageButtonWrapper__STa1P"};